(function () {
    'use strict';

    function eoTagsController($scope, MetaTagCustom) {
        var $ctrl = this;


        $ctrl.selectedItem = null;
        $ctrl.searchText = null;
        $ctrl.querySearch = querySearch;
        $ctrl.tags = [];

        $ctrl.selectedTagsArray = [];
        $ctrl.selectedTagsChange = selectedTagsChange;
        var isInternalChange = false;


        loadTags();
        $scope.$watch('$ctrl.selectedTags', function () {
            if (isInternalChange)
                return;
            if ($ctrl.selectedTags != undefined && $ctrl.selectedTags != null && $ctrl.selectedTags != "") {
                var arr = $ctrl.selectedTags.split(',');
                $ctrl.selectedTagsArray = [];
                for (var i = 0; i < arr.length; i++) {
                    var item = {};
                    item.name = arr[i];
                    $ctrl.selectedTagsArray.push(item);
                }
            }

        });

        function loadTags() {

            var type = 'ALL';
            if ($ctrl.tagType != null && $ctrl.tagType != undefined && $ctrl.tagType != '')
                type = $ctrl.tagType;

            MetaTagCustom.getMetaTagsByType(type).query().$promise.then(function (result) {

                $ctrl.tags = [];
                for (var i = 0; i < result.length; i++) {
                    var item = {};
                    item.name = result[i].tag;
                    $ctrl.tags.push(item);
                }


            });

            // var tags = [
            //     {
            //         'name': 'فضا'
            //     },{
            //         'name': 'اتاق'
            //     },{
            //         'name': 'جلسه'
            //     },{
            //         'name': 'استخر'
            //     },{
            //         'name': 'استادیوم'
            //     },{
            //         'name': 'استودیو'
            //     }
            // ];

            // return tags ;
        }

        function querySearch(query) {

            return $ctrl.tags.filter(function (el) {
                return el.name.indexOf(query) !== -1
            })

        }

        function selectedTagsChange() {

            isInternalChange = true;
            $ctrl.selectedTags = "";
            for (var i = 0; i < $ctrl.selectedTagsArray.length; i++) {

                $ctrl.selectedTags += $ctrl.selectedTagsArray[i].name.toString();
                if (i + 1 != $ctrl.selectedTagsArray.length) {
                    $ctrl.selectedTags += ",";
                }
            }

            // isInternalChange = false;
        }

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */


    }

    var eoTagsController = {

        templateUrl: 'app/components/eyeson/tags/eyeson.tags.template.html',
        controller: eoTagsController,
        bindings: {

            selectedTags: '=',
            tagType: '<?'
        }
    };
    angular
        .module('tikonApp')
        .component('eoTags', eoTagsController);
    eoTagsController.$inject = ['$scope', 'MetaTagCustom'];
})();

